import { convertRemToPx } from '@hivebrite/design-system/Theme';

export const HEADINGS_VALUES = Object.freeze({
  px: {
    isMobile: {
      h1: {
        fontSize: `${convertRemToPx(2.3)}px`,
        lineHeight: `${convertRemToPx(2.8)}px`,
      },
      h2: {
        fontSize: `${convertRemToPx(1.7)}px`,
        lineHeight: `${convertRemToPx(2.1)}px`,
      },
      h3: {
        fontSize: `${convertRemToPx(1.4)}px`,
        lineHeight: `${convertRemToPx(1.7)}px`,
      },
      h4: {
        fontSize: `${convertRemToPx(1.2)}px`,
        lineHeight: `${convertRemToPx(1.5)}px`,
      },
    },
    isDesktop: {
      h1: {
        fontSize: `${convertRemToPx(2.5)}px`,
        lineHeight: `${convertRemToPx(3)}px`,
      },
      h2: {
        fontSize: `${convertRemToPx(1.8)}px`,
        lineHeight: `${convertRemToPx(2.2)}px`,
      },
      h3: {
        fontSize: `${convertRemToPx(1.5)}px`,
        lineHeight: `${convertRemToPx(1.8)}px`,
      },
      h4: {
        fontSize: `${convertRemToPx(1.2)}px`,
        lineHeight: `${convertRemToPx(1.5)}px`,
      },
    },
  },
  rem: {
    isMobile: {
      h1: { fontSize: '2.3rem', lineHeight: '2.8rem' },
      h2: { fontSize: '1.7rem', lineHeight: '2.1rem' },
      h3: {
        fontSize: '1.4rem',
        lineHeight: '1.7rem',
      },
      h4: {
        fontSize: '1.2rem',
        lineHeight: '1.5rem',
      },
    },
    isDesktop: {
      h1: { fontSize: '2.5rem', lineHeight: '3rem' },
      h2: { fontSize: '1.8rem', lineHeight: '2.2rem' },
      h3: {
        fontSize: '1.5rem',
        lineHeight: '1.8rem',
      },
      h4: {
        fontSize: '1.2rem',
        lineHeight: '1.5rem',
      },
    },
  },
});
